module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/7_1-d4f8f1d302545d9edf2d1aa6c601f71e.png";